import { createAction } from '@reduxjs/toolkit';

import { INIT_CONVERSATION_CONTROL, HANDLE_SPEED_SELECT } from './actionTypes';

export const initConversationControl = createAction(INIT_CONVERSATION_CONTROL);
export const handleSpeedSelect = createAction<string>(HANDLE_SPEED_SELECT);
